export function hex2rgb(hex) {
  hex = hex.replace(/^#/, "");
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  }
  if (hex.length !== 6) {
    throw new Error("Invalid HEX color.");
  }
  let r = parseInt(hex.slice(0, 2), 16);
  let g = parseInt(hex.slice(2, 4), 16);
  let b = parseInt(hex.slice(4, 6), 16);
  let Color = { isColor: true, r: r, g: g, b: b };
  return Color;
}
export function color2Hex(color) {
  let r = Number(color.r) * 255;
  let g = Number(color.g) * 255;
  let b = Number(color.b) * 255;
  return r.toString(16).padStart(2, "0") + g.toString(16).padStart(2, "0") + b.toString(16).padStart(2, "0");
}
export function smoothScrollToParent(list, item, duration = 300) {
  const start = list.scrollTop;
  const itemTop = item.offsetTop;
  const itemHeight = item.offsetHeight;
  const listHeight = list.clientHeight;

  // Calculate target scrollTop to center the item
  const target = itemTop - listHeight / 2 + itemHeight / 2;
  const distance = target - start;

  let startTime = null;

  function animation(currentTime) {
    if (!startTime) startTime = currentTime;
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    // Ease function (easeInOutQuad)
    const ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;

    list.scrollTop = start + distance * ease;

    if (elapsed < duration) {
      requestAnimationFrame(animation);
    }
  }
  requestAnimationFrame(animation);
}
